import { render, staticRenderFns } from "./send-notification-modal.vue?vue&type=template&id=5cf2ddb1&"
import script from "./send-notification-modal.vue?vue&type=script&lang=js&"
export * from "./send-notification-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "send-notification-modal.vue"
export default component.exports